import store from '@/store'
import RoomAvatar from './RoomAvatar.js'
import RedNum from "_com/func/RedNum.vue";
import unread from '_lib/unreadState';
import badger from "_lib/Badger"
import Vue from 'vue';
import RoomItemUsers from "../../room-short-cuts/RoomItemUsers.vue";
import { getEmojiHtml } from '@/directives/emojiHtmlDirective';
import { getSparkRoomLevel, getShowSparkRoomMinDay, getSparkRoomConfig } from '_lib/constants/spark'
import { initTooltip, destroyTooltip } from './tooltip.js'
import { checkIsMute } from '@/common/notifySettings'
import { IMTimeFormat } from '_lib/utils/utils'
class RoomItemRenderer {
  constructor() {
    this.rooms = new Map();
    this.roomAvatars = new Map();
    this.tempRooms = new Map();
    this.tempRoomAvatars = new Map();
  }
  get cur_room_data () {
    return store.getters.cur_room_data;
  }
  render (args) {
    const room = args.room;
    if (!room) {
      return '';
    }
    const roomAvatar = new RoomAvatar({
      room_name: room.room_name,
      img: room.room_avatar,
      width: 42,
      icon_width: 18,
      keep_active: room.room_id === this.cur_room_data.room_id,
      webp_quality: 30,
      chat_img_props: {
        gif_active_type: 'selected',
        is_active: room.room_id === this.cur_room_data.room_id,
      },
    });
    if (args.isTemp) {
      this.tempRooms.set(room.room_id, room);
      this.tempRoomAvatars.set(room.room_id, roomAvatar);
    } else {
      this.rooms.set(room.room_id, room);
      this.roomAvatars.set(room.room_id, roomAvatar);
    }
    const iconClass = this.stateIconClass(room);
    const isChannelActive = !store.getters.channel_connecting && store.getters.cur_channel_data.room_id === room.room_id;
    const html = `
      <div
        class="cpt-shortcut-block-wrapper${args.className ? ` ${args.className}` : ''}"
        data-room-id="${room.room_id}"
        data-delegate-dragenter-room
        data-delegate-dragover-room
        data-delegate-dragleave-room
        data-delegate-drop-room
      >
        <div
          class="shortcut-block${this.cur_room_data.room_id === args.room.room_id ? ' active' : ''}" 
          ${args.draggable ? 'draggable="true"' : ''} 
          data-delegate-click-room
          data-delegate-ctxmenu-room
          data-delegate-dragstart-room
          ${args.temp_type ? `data-temp-type="${args.temp_type}"` : ''}
        >
          ${roomAvatar.render()}
          ${
            iconClass ? `<i class="iconfont icon-room-state ${iconClass}${isChannelActive ? ' active' : ''}"></i>` : ''
          }
          ${this.renderRedNum(room)}
        </div>
      </div>
    `
    return html;
  }
  initEvents(args, baseEl) {
    const room = args.room;
    if (!room) return;
    const roomAvatar = args.isTemp ? this.tempRoomAvatars.get(room.room_id) : this.roomAvatars.get(room.room_id);
    baseEl = baseEl || this.getBaseEl(room.room_id);
    if (roomAvatar && baseEl) {
      roomAvatar.initEvents(baseEl);
    }
    const shortcutBlock = baseEl.querySelector('.shortcut-block');
    if (shortcutBlock) {
      const data = {
        placement: 'right',
        popperClass: 'room-shortcut-tooltip',
        getTextFn: () => {
          return this.renderTooltipContent((args.isTemp ? this.tempRooms : this.rooms).get(room.room_id) || room)
        }
      }
      shortcutBlock && initTooltip(shortcutBlock, data);
    }
  }
  // 
  getBaseEl(roomId, isTemp) {
    const selector = `.cpt-shortcut-block-wrapper[data-room-id="${roomId}"]`
    if (isTemp) {
      return document.querySelector(`.temp-room ${selector}`);
    }
    return document.querySelector(selector);
  }
  destroy(args) {
    let room_id = args?.room_id || args?.room?.room_id;
    if (!room_id) return;
    const roomAvatar = args.isTemp ? this.tempRoomAvatars.get(room_id) : this.roomAvatars.get(room_id);
    const baseEl = this.getBaseEl(room_id, args.isTemp);
    if (roomAvatar && baseEl) {
      roomAvatar.destroy(baseEl);
    }
    if (args.isTemp) {  
      this.tempRoomAvatars.delete(room_id);
      this.tempRooms.delete(room_id);
    } else {
      this.roomAvatars.delete(room_id);
      this.rooms.delete(room_id);
    }
    const shortcutBlock = baseEl?.querySelector('.shortcut-block');
    shortcutBlock && destroyTooltip(shortcutBlock);
  }
  unreadState (room) {
    const v = unread.getUnreadState({room_id: room.room_id})
    if (window.client_env !== 'electron') {
      badger.updateRoomUnreadCount(v.redCount, room.room_id)
    }
    return v
  }
  renderRedNum(room) {
    const unreadState = this.unreadState(room);
    const show_theme_data = store.getters.show_theme_data;
    if (unreadState.redCount) {
      const RedNumCtr = Vue.extend(RedNum);
      const redNumEl = new RedNumCtr({
        propsData: {
          borderColor: show_theme_data.bar_color ? show_theme_data.bar_color[0] : '',
          isHasBorder: true,
          num: unreadState.redCount,
        },
      });
      return redNumEl.$mount().$el.outerHTML;
    } else if (unreadState.showRedPoint) {
      return `<div class="red-point"></div>`;
    }
    return '';
  }
  
  stateIconClass (room) {
    if (checkIsMute(room.room_id)) {
      return ''
    }
    if(room.room_act_info){
      return 'icon-calendar'
    } else if (room.promise_info) {
      return 'icon-fight'
    } else if (room.screen_share_members?.length > 0) {
      return 'icon-pcshare'
    } else if (room.audio_share_members?.length > 0) {
      return 'icon-music'
    } else if (room.audio_count) {
      return 'icon-speak-on'
    }
    return ''
  }
  sparkData(room) {
    return {
      continuous_days: room.continuous_days,
      cumulative_days: room.cumulative_days,
      active_members: room.active_members,
    }
  }
  getTooltipRoomName(room) {
    const contentHtml = getEmojiHtml(room.room_name, { width: '14px' })
    const hasRoomIcon = room.room_icon?.length
    const hasSpark = !room.is_public && !room.hide_room_fire_flag && room.cumulative_days >= getShowSparkRoomMinDay()

    const roomIconHtml = hasRoomIcon ? `<div class="room-icon"><img src="${room.room_icon[0].icon}"/></div>` : ''
    const sparkLevel = getSparkRoomLevel(room.continuous_days, room.cumulative_days, room.active_members)
    const sparkConfig = getSparkRoomConfig(sparkLevel)
    const sparkHtml = hasSpark ? `<div class="cpt-spark-wrapper"><div class="spark-icon"><img src="${sparkConfig.icon}" /></div><div class="spark-count"><span style="background-image: ${sparkConfig.text_bg}">${this.sparkData(room).cumulative_days}</span></div></div>` : ''
    return `${roomIconHtml}${contentHtml}${sparkHtml}`
  }
  renderTooltipContent(room) {
    let room_act_html = '';
    const bar_color = store.getters.show_theme_data?.bar_color;
    if (room.room_act_info) {
      room_act_html = `
        <div class="tooltip-layout-room-activity">
          <i class="iconfont icon-calendar" style="${bar_color ? `border-color:${bar_color[0]};` : ''}"></i>
          <span class="text">${room.room_act_info.text}</span>
          <span class="count">等 ${room.room_act_info.count} 场活动</span>
        </div>
      `
    }
    let room_team_html = '';
    if (room.promise_info) {
      room_team_html = `
        <div class="tooltip-layout-room-team">
          <i class="iconfont icon-fight" style="${bar_color ? `border-color:${bar_color[0]};` : ''}"></i>
          <span class="text">${room.promise_info.text}</span>
          <span class="count">等 ${room.promise_info.count} 场邀约</span>
        </div>
      `
    }
    let room_users_html = '';
    const members = [{
      list: room.members,
      sum_num: room.audio_count,
    }, {
      list: room.screen_share_members,
      icon: 'icon-pcshare',
    }, {
      list: room.audio_share_members,
      icon: 'icon-music',
    }]
    members.forEach(member => {
      if (member.list && member.list.length > 0) {
        const props = {
          list: member.list,
          sum_num: member.sum_num,
          show_theme_data: store.getters.show_theme_data,
          icon: member.icon,
        }
        room_users_html += this.renderItemUsers(props)
      }
    })
    let mute_html = ''
    const mute = checkIsMute(room.room_id)
    if (mute) {
      let mute_text = '已开启免打扰'
      if (mute.second > 0) {
        mute_text = `免打扰至：${IMTimeFormat(mute.left_mute_time * 1000, false, false)}`
      }
      mute_html = `
        <div class="tooltip-layout-room-mute">
          <i class="iconfont icon-notice-off"></i>
          <span>${mute_text}</span>
        </div>
      `
    }
    return `
      <div class="tooltip-container">
        <div class="tooltip-layout-room-name">
          <div class="name">${this.getTooltipRoomName(room)}</div>
        </div>
        ${room_act_html}
        ${room_team_html}
        ${room_users_html}
        ${mute_html}
      </div>
    `
  }
  renderItemUsers(props) {
    if (props.list.length > 0) {
      const RoomItemUsersCtr = Vue.extend(RoomItemUsers);
      const roomItemUsersEl = new RoomItemUsersCtr({
        propsData: props,
      });
      return roomItemUsersEl.$mount().$el.outerHTML;
    }
    return ''
  }
  updateRoomData (room) {
    this.rooms.set(room.room_id, room);
  }
  updateCurRoomId (newId, oldId) {
    const oldRoomAvatar = this.roomAvatars.get(oldId);
    const newRoomAvatar = this.roomAvatars.get(newId);
    if (oldRoomAvatar) {
      oldRoomAvatar.updateImgIsActive(false);
    }
    if (newRoomAvatar) {
      newRoomAvatar.updateImgIsActive(true);
    }
  }
}

const renderInstance = new RoomItemRenderer();
export default renderInstance;